// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__zjPVp","headerTitle":"styles_headerTitle__Dv3zY","headerContent":"styles_headerContent__QSdjk","trashIcon":"styles_trashIcon__K0J6v"};